import { Color } from 'style/types';

export const playerScoreThresholds = [
  [14.5, 'veryLow'],
  [29.5, 'low'],
  [44.5, 'mediumLow'],
  [59.5, 'medium'],
  [74.5, 'mediumHigh'],
] as const;

const teamScoreThresholds = [
  [72.5, 'veryLow'],
  [147.5, 'low'],
  [222.5, 'mediumLow'],
  [197.5, 'medium'],
  [372.5, 'mediumHigh'],
] as const;

const thresholds = [
  [24.5, 'veryLow'],
  [39.5, 'low'],
  [59.5, 'mediumLow'],
  [74.5, 'medium'],
  [89.5, 'mediumHigh'],
] as const;

export const THRESHOLD_COLORS: { [key: string]: Color } = {
  veryLow: 'var(--c-score-veryLow)',
  low: 'var(--c-score-low)',
  mediumLow: 'var(--c-score-mediumLow)',
  medium: 'var(--c-score-medium)',
  mediumHigh: 'var(--c-score-mediumHigh)',
  high: 'var(--c-score-high)',
};

export type ScoreType = 'CARD_SCORE' | 'PLAYER_SCORE' | 'TEAM_SCORE';

export const MAX_SCORE = 100;

export const findThreshold = (
  score: number,
  type: ScoreType = 'PLAYER_SCORE'
) => {
  let values;
  if (type === 'PLAYER_SCORE') {
    values = playerScoreThresholds;
  } else if (type === 'TEAM_SCORE') {
    values = teamScoreThresholds;
  } else {
    values = thresholds;
  }

  const threshold = values.find(t => Number(t[0]) > score);

  return threshold ? threshold[1] : 'high';
};
